import { commons, concessionLetterRequired, others } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const MAIANDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCarta: dynamicRule('required'),
    anexoOutros: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...concessionLetterRequired, ...others],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
